/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CategoryAmountDTO,
  CategoryAmountDTOOptional,
  CategoryAmountDTOMetaI,
  CategoryAmountDTOTrackedI,
} from "./category-amount-dto";
import {
  CategoryAmountDTOTracked,
  CategoryAmountDTOMeta,
} from "./category-amount-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentTypeAmountDTO,
  PaymentTypeAmountDTOOptional,
  PaymentTypeAmountDTOMetaI,
  PaymentTypeAmountDTOTrackedI,
} from "./payment-type-amount-dto";
import {
  PaymentTypeAmountDTOTracked,
  PaymentTypeAmountDTOMeta,
} from "./payment-type-amount-dto";

/**
 *
 * @export
 * @interface DailySummaryReportBase
 */
export interface DailySummaryReportBaseOptional {
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportBase
   */
  totalAmountItems?: number;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportBase
   */
  totalAmountPayments?: number;
  /**
   *
   * @type {Array<CategoryAmountDTO>}
   * @memberof DailySummaryReportBase
   */
  categoryAmounts?: CategoryAmountDTOOptional[];
  /**
   *
   * @type {Array<PaymentTypeAmountDTO>}
   * @memberof DailySummaryReportBase
   */
  paymentTypeAmounts?: PaymentTypeAmountDTOOptional[];
}

export interface DailySummaryReportBase extends DailySummaryReportBaseOptional {
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportBase
   */
  totalAmountItems?: number;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportBase
   */
  totalAmountPayments?: number;
  /**
   *
   * @type {Array<CategoryAmountDTO>}
   * @memberof DailySummaryReportBase
   */
  categoryAmounts?: CategoryAmountDTO[];
  /**
   *
   * @type {Array<PaymentTypeAmountDTO>}
   * @memberof DailySummaryReportBase
   */
  paymentTypeAmounts?: PaymentTypeAmountDTO[];
}

export interface DailySummaryReportBaseTrackedI {
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportBase
   */
  totalAmountItems?: number;
  totalAmountItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportBase
   */
  totalAmountPayments?: number;
  totalAmountPaymentsIsSet: boolean;
  /**
   *
   * @type {Array<CategoryAmountDTO>}
   * @memberof DailySummaryReportBase
   */
  categoryAmounts?: CategoryAmountDTOTrackedI[];
  categoryAmountsIsSet: boolean;
  /**
   *
   * @type {Array<PaymentTypeAmountDTO>}
   * @memberof DailySummaryReportBase
   */
  paymentTypeAmounts?: PaymentTypeAmountDTOTrackedI[];
  paymentTypeAmountsIsSet: boolean;
}

transformDatesMap.set(
  "DailySummaryReportBase",
  function (model: DailySummaryReportBase) {
    const transformDatescategoryAmounts =
      transformDatesMap.get("CategoryAmountDTO");
    if (transformDatescategoryAmounts) {
      model.categoryAmounts?.forEach((sub) => {
        transformDatescategoryAmounts(sub);
      });
    }
    const transformDatespaymentTypeAmounts = transformDatesMap.get(
      "PaymentTypeAmountDTO",
    );
    if (transformDatespaymentTypeAmounts) {
      model.paymentTypeAmounts?.forEach((sub) => {
        transformDatespaymentTypeAmounts(sub);
      });
    }
  },
);

export type DailySummaryReportBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  totalAmountItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountPayments: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  categoryAmounts: PropertyMeta<CategoryAmountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  paymentTypeAmounts: PropertyMeta<PaymentTypeAmountDTOMetaI>;
}>;

export var DailySummaryReportBaseMeta: DailySummaryReportBaseMetaI =
  {} as DailySummaryReportBaseMetaI;
DailySummaryReportBaseMeta = typeMeta("DailySummaryReportBase", {
  totalAmountItems: propertyMeta(
    "totalAmountItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountPayments: propertyMeta(
    "totalAmountPayments",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  categoryAmounts: propertyMeta(
    "categoryAmounts",
    true,
    false,
    false,
    CategoryAmountDTOMeta,
  ),
  paymentTypeAmounts: propertyMeta(
    "paymentTypeAmounts",
    true,
    false,
    false,
    PaymentTypeAmountDTOMeta,
  ),
});

const metaI = DailySummaryReportBaseMeta;

registerMeta(() => {});

export class DailySummaryReportBaseTracked implements DailySummaryReportBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  totalAmountItems__I?: number = undefined;
  totalAmountItemsIsSet: boolean = false;
  set totalAmountItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountItems__I = v;
      this.totalAmountItemsIsSet = true;
    } else {
      this.totalAmountItems__I = v || undefined;
      this.totalAmountItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountItems() {
    return this.totalAmountItems__I;
  }
  totalAmountPayments__I?: number = undefined;
  totalAmountPaymentsIsSet: boolean = false;
  set totalAmountPayments(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountPayments__I = v;
      this.totalAmountPaymentsIsSet = true;
    } else {
      this.totalAmountPayments__I = v || undefined;
      this.totalAmountPaymentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountPayments() {
    return this.totalAmountPayments__I;
  }
  categoryAmounts__I?: CategoryAmountDTOTracked[] = undefined;
  categoryAmountsIsSet: boolean = false;
  set categoryAmounts(v: undefined | CategoryAmountDTOTracked[]) {
    if (v !== undefined) {
      this.categoryAmounts__I = v;
      this.categoryAmountsIsSet = true;
    } else {
      this.categoryAmounts__I = v || undefined;
      this.categoryAmountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get categoryAmounts() {
    return this.categoryAmounts__I;
  }
  paymentTypeAmounts__I?: PaymentTypeAmountDTOTracked[] = undefined;
  paymentTypeAmountsIsSet: boolean = false;
  set paymentTypeAmounts(v: undefined | PaymentTypeAmountDTOTracked[]) {
    if (v !== undefined) {
      this.paymentTypeAmounts__I = v;
      this.paymentTypeAmountsIsSet = true;
    } else {
      this.paymentTypeAmounts__I = v || undefined;
      this.paymentTypeAmountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentTypeAmounts() {
    return this.paymentTypeAmounts__I;
  }
  constructor(
    config?: DailySummaryReportBaseOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.categoryAmounts?.forEach((a) => a.setIds());

    this.paymentTypeAmounts?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: DailySummaryReportBaseOptional,
    options?: AssignOptions,
  ): DailySummaryReportBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.totalAmountItems &&
      this.totalAmountItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountItems = config.totalAmountItems;
      if (optionsRequired.unassign) this.totalAmountItemsIsSet = false;
      else this.totalAmountItemsIsSet = true;
    }
    if (
      config.totalAmountPayments &&
      this.totalAmountPaymentsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountPayments = config.totalAmountPayments;
      if (optionsRequired.unassign) this.totalAmountPaymentsIsSet = false;
      else this.totalAmountPaymentsIsSet = true;
    }
    if (
      config.categoryAmounts &&
      this.categoryAmountsApplyFilter(optionsRequired.filter)
    ) {
      this.categoryAmounts = config.categoryAmounts?.map(
        (a) => new CategoryAmountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.categoryAmountsIsSet = false;
      else this.categoryAmountsIsSet = true;
    }
    if (
      config.paymentTypeAmounts &&
      this.paymentTypeAmountsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentTypeAmounts = config.paymentTypeAmounts?.map(
        (a) => new PaymentTypeAmountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.paymentTypeAmountsIsSet = false;
      else this.paymentTypeAmountsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DailySummaryReportBaseTrackedI {
    const cloned = {} as DailySummaryReportBaseTrackedI;
    if (
      this.totalAmountItemsIsSetDeep() &&
      this.totalAmountItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountItemsIsSet = true;
      cloned.totalAmountItems = this.totalAmountItems;
    } else {
      //cloned.totalAmountItemsIsSet = false
    }
    if (
      this.totalAmountPaymentsIsSetDeep() &&
      this.totalAmountPaymentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountPaymentsIsSet = true;
      cloned.totalAmountPayments = this.totalAmountPayments;
    } else {
      //cloned.totalAmountPaymentsIsSet = false
    }
    if (
      this.categoryAmountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.categoryAmountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoryAmountsIsSet = true;
      cloned.categoryAmounts = this.categoryAmounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.categoryAmountsIsSet = false
    }
    if (
      this.paymentTypeAmountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.paymentTypeAmountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeAmountsIsSet = true;
      cloned.paymentTypeAmounts = this.paymentTypeAmounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.paymentTypeAmountsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DailySummaryReportBaseTrackedI {
    if (!this.totalAmountItemsApplyFilter(filter))
      this.totalAmountItemsIsSet = false;

    if (!this.totalAmountPaymentsApplyFilter(filter))
      this.totalAmountPaymentsIsSet = false;

    if (!this.categoryAmountsApplyFilter(filter))
      this.categoryAmountsIsSet = false;

    this.categoryAmounts?.forEach((a) => a.unassignAll(filter));
    if (!this.paymentTypeAmountsApplyFilter(filter))
      this.paymentTypeAmountsIsSet = false;

    this.paymentTypeAmounts?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  totalAmountItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportBaseMeta.totalAmountItems,
      DailySummaryReportBaseMeta,
      this.totalAmountItems,
      this,
    );
  }
  totalAmountItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.totalAmountItemsIsSet && this.totalAmountItemsApplyFilter(filter))
      return true;

    return false;
  }
  totalAmountPaymentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportBaseMeta.totalAmountPayments,
      DailySummaryReportBaseMeta,
      this.totalAmountPayments,
      this,
    );
  }
  totalAmountPaymentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountPaymentsIsSet &&
      this.totalAmountPaymentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  categoryAmountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportBaseMeta.categoryAmounts,
      DailySummaryReportBaseMeta,
      this.categoryAmounts,
      this,
    );
  }
  categoryAmountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoryAmountsIsSet && this.categoryAmountsApplyFilter(filter))
      return true;

    return this.categoryAmounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  paymentTypeAmountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportBaseMeta.paymentTypeAmounts,
      DailySummaryReportBaseMeta,
      this.paymentTypeAmounts,
      this,
    );
  }
  paymentTypeAmountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentTypeAmountsIsSet &&
      this.paymentTypeAmountsApplyFilter(filter)
    )
      return true;

    return this.paymentTypeAmounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.totalAmountItemsIsSetDeep(filter)) return true;
    if (this.totalAmountPaymentsIsSetDeep(filter)) return true;
    if (this.categoryAmountsIsSetDeep(filter)) return true;
    if (this.paymentTypeAmountsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
